import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { NotificationType } from '../../redux/types';
import FaveNotification from '../../../FaveButton/FaveNotification';
import CollectNotification from '../../../CollectionPanel/CollectNotification';
import CommentDeleteNotification from '../../../CommentDeleteNotification';
import GroupAddedNotification from '../../../AddToGroupsPanel/_partials/GroupAddedNotification';
import LiveNotification from '../../../LiveNotifications/LiveNotification';
import BadgeNotification from '../../../coreBadge/BadgeNotification';
import GenericNotification from '../../GenericNotification';
const NotificationContent = ({ notification , removeNotification , children  })=>{
    if (!notification) {
        return null;
    }
    switch(notification.type){
        case NotificationType.Collect:
        case NotificationType.CollectPrivate:
        case NotificationType.CollectUndo:
            return /*#__PURE__*/ React.createElement(CollectNotification, _extends({
                id: notification.id,
                queueName: notification.queueName,
                type: notification.type,
                removeNotification: removeNotification
            }, notification.params));
        case NotificationType.Fave:
        case NotificationType.FaveUndo:
            return /*#__PURE__*/ React.createElement(FaveNotification, _extends({
                id: notification.id,
                queueName: notification.queueName,
                type: notification.type,
                removeNotification: removeNotification
            }, notification.params));
        case NotificationType.DeleteComment:
            return /*#__PURE__*/ React.createElement(CommentDeleteNotification, _extends({
                id: notification.id,
                queueName: notification.queueName,
                type: notification.type,
                removeNotification: removeNotification
            }, notification.params));
        case NotificationType.AddToGroup:
            return /*#__PURE__*/ React.createElement(GroupAddedNotification, _extends({
                id: notification.id,
                queueName: notification.queueName
            }, notification.params));
        case NotificationType.Live:
            return /*#__PURE__*/ React.createElement(LiveNotification, _extends({
                id: notification.id,
                queueName: notification.queueName,
                notificationHtml: notification.params.message,
                biData: notification.params.bi_data,
                linkTo: notification.params.url
            }, notification.params));
        case NotificationType.Generic:
            return /*#__PURE__*/ React.createElement(GenericNotification, _extends({
                id: notification.id,
                queueName: notification.queueName
            }, notification.params));
        case NotificationType.Badge:
            return /*#__PURE__*/ React.createElement(BadgeNotification, _extends({
                id: notification.id,
                queueName: notification.queueName,
                removeNotification: removeNotification
            }, notification.params));
        default:
            if (!children) {
                return null;
            }
            return /*#__PURE__*/ React.createElement(React.Fragment, null, children(notification, removeNotification));
    }
};
NotificationContent.displayName = 'NotificationContent';
export default NotificationContent;
